import { render, staticRenderFns } from "./SyncSchedules.vue?vue&type=template&id=2c2567b6&scoped=true&lang=pug"
import script from "./SyncSchedules.vue?vue&type=script&lang=js"
export * from "./SyncSchedules.vue?vue&type=script&lang=js"
import style0 from "./SyncSchedules.vue?vue&type=style&index=0&id=2c2567b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2567b6",
  null
  
)

export default component.exports